import type { TranslationKey } from '../i18n/he';

export type BillingInterval = 'month' | 'year';

/**
 * The short feature summary shown under the Premium plan on the pricing page
 * and in the in-app upgrade screen. Edit this list to change what's shown;
 * the actual entitlements it describes live in PREMIUM_FEATURE_PLANS on the
 * backend.
 */
export const PREMIUM_FEATURE_KEYS: readonly TranslationKey[] = [
  'planPremium1', 'planPremium2', 'planPremium3', 'planPremium4',
  'planPremium5', 'planPremium6', 'planPremium7', 'planPremium8'
];
